<template>
  <div>

    <b-card-code
        title="Ki anlernen"
    >
      <b-button @click="Next">
        Weiter
      </b-button>
      <b-row v-show="FileName != ''">
        <b-col
            md="8"
            class="mb-1"
        >
          <vue-pdf-app style="height: 100vh;" :pdf="file"></vue-pdf-app>
        </b-col>

        <b-col
            md="4"
        >

          <b-row>
            <b-col
                md="4"
            >
              <b-form-group
                  label="Anzahl Pickups"
              >
                <b-form-select
                    v-model="pickupCount"
                    :options="[1,2,3,4,5,6,8,9,10]"
                    @change="ChangePickups()"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
            >
              <b-form-group
                  label="PDF-Datum"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker
                        :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                        button-only
                        :start-weekday="1"
                        locale="de-DE"
                        color="danger"
                        @context="onContextFile"
                    />
                  </b-input-group-prepend>

                  <cleave
                      v-model="FileDate"
                      class="form-control"
                      :raw="false"
                      :options="options.date"
                      placeholder="dd.mm.yy"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
                md="4"
            >
              <b-form-group
                  label="PDF/Time"
              >
                <cleave
                    v-model="FileTime"
                    class="form-control"
                    :raw="false"
                    :options="options.time"
                    placeholder="hh:mm"
                    ref="PickupTime2"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
                md="6"
            >
              <b-form-group
                  label="Datum"
              >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-form-datepicker
                        :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                        button-only
                        :start-weekday="1"
                        locale="de-DE"
                        color="danger"
                        @context="onContext"
                    />
                  </b-input-group-prepend>

                  <cleave
                      v-model="TravelDay"
                      class="form-control"
                      :raw="false"
                      :options="options.date"
                      placeholder="dd.mm.yy"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
                md="6"
            >
              <b-form-group
                  label="Richtung"
              >
                <b-form-select
                    v-model="Route"
                    :options="pageOptions"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
              v-for="(pickup, index)  in pickups"
          >
            <b-col
                md="12"
            >
              <hr>
            </b-col>
            <b-col
                md="3"
            >
              <b-form-group
                  label="Flugnummer"
              >
                <b-form-input
                    v-model="pickup.Iata"
                    @keyup="pickup.Iata = pickup.Iata.toUpperCase()"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
            >
              <b-form-group
                  label="Pickup"
              >
                <cleave
                    v-model="pickup.Pickup"
                    class="form-control"
                    :raw="false"
                    :options="options.time"
                    placeholder="hh:mm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
            >
              <b-form-group
                  label="End"
              >
                <cleave
                    v-model="pickup.End"
                    class="form-control"
                    :raw="false"
                    :options="options.time"
                    placeholder="hh:mm"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="3"
            >
              <b-form-group
                  label="FROM/TO"
              >
                <b-form-input
                    v-model="pickup.From"
                    @keyup="pickup.From = pickup.From.toUpperCase()"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="4"
            >
              <b-form-group
                  label="Anzahl Crewmember"
              >
                <cleave
                    v-model="pickup.CrewMemberCount"
                    :options="options.number"
                    class="form-control"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="8"
            >
              <b-form-group
                  label="DeadHed"
                  :label-for="'dh'+index"
              >
                <b-form-checkbox
                <b-form-checkbox
                    :id="'dh'+index"
                    v-model="pickup.DeadHead"
                />
              </b-form-group>
            </b-col>
            <b-col
                md="12"
            >
              <b-form-group
                  label="Crewmember"
              >
                <b-form-textarea
                    v-model="pickup.CrewMember"
                    @change="Replace(pickup)"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-button @click="Save" class="btn-block btn-success">
            Speichern
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>

  </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { BAvatar, BBadge, BButton, BCol, BDropdown, BDropdownItem, BFormDatepicker, BFormGroup, BFormInput, BFormSelect, BInputGroup, BInputGroupAppend, BPagination, BRow, BSpinner, BTab, BTable, BTabs, BFormTextarea, BInputGroupPrepend, BFormCheckbox } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import visualDefault from 'echarts/src/visual/visualDefault'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import date from 'vue-good-table/src/components/types/date'
import VuePdfApp from 'vue-pdf-app'

import pdf from 'vue-pdf'

export default {
  name: 'KiPdf',
  components: {
    ValidationProvider,
    ValidationObserver,
    BTabs,
    BTab,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BFormTextarea,
    BCol,
    BFormCheckbox,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BFormDatepicker,
    Cleave,
    BSpinner,
    pdf,
    VuePdfApp,

  },
  directives: {
    Ripple,
  },
  props: {
    mapConfig: Object,
  },
  data() {
    return {
      file: '',
      loading: false,
      FileName: '',
      FileTime: '',
      Route: '',
      FileDate: '',
      pickupCount: 1,
      TravelDay: '',
      toLej: false,
      pageOptions: [
        {
          value: 'LEJ-Hotel',
          text: 'LEJ => Hotel'
        },
        {
          value: 'Hotel-LEJ',
          text: 'Hotel => LEJ'
        },
        {
          value: 'QLJ-LEJ',
          text: 'QLJ => LEJ'
        },
        {
          value: 'LEJ-QLJ',
          text: 'LEJ => QLJ'
        },
        {
          value: 'LEJ-BER',
          text: 'LEJ => BER'
        },
        {
          value: 'BER-LEJ',
          text: 'BER => LEJ'
        },
        {
          value: 'LEJ-FRA',
          text: 'LEJ => FRA'
        },
        {
          value: 'FRA-LEJ',
          text: 'FRA => LEJ'
        },
        {
          value: 'LEJ-HAM',
          text: 'LEJ => HAM'
        },
        {
          value: 'HAM-LEJ',
          text: 'HAM => LEJ'
        },
      ],
      pickups: [],
      options: {
        Time2Label: 'Abflug',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
        number: {
          numericOnly: true,
          blocks: [16],
          delimiters: ['']
        },

      },
    }
  },

  mounted() {
    this.ChangePickups()
  },
  methods: {
    Replace(pickup) {
      pickup.CrewMember = pickup.CrewMember.replace('04105', '')
      pickup.CrewMember = pickup.CrewMember.replace('Gerberstr. 15', '')
      pickup.CrewMember = pickup.CrewMember.replace('Leipzig', '')
      pickup.CrewMember = pickup.CrewMember.replace('Location Details:', '')
      pickup.CrewMember = pickup.CrewMember.replace(' ', '')
      pickup.CrewMember = pickup.CrewMember.replace('\n', '')
      pickup.CrewMember = pickup.CrewMember.replace(/\s/g, '')
    },
    ChangePickups() {
      this.pickups = []
      for (let i = 0; i < this.pickupCount; i++) {
        this.pickups.push({
          Iata: '',
          From: '',
          Pickup: '',
          End: '',
          CrewMemberCount: 1,
          DeadHead: false,
          CrewMember: '',
        })
      }

    },
    onContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.fieldData = ctx.activeFormatted
        this.TravelDay = ctx.activeFormatted
      }
    },
    onContextFile(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.FileDate = ctx.activeFormatted
      }
    },
    Reset() {
      this.FileName = ''
      this.FileDate = ''
      this.FileTime = ''
      this.TravelDay = ''
      this.pickups = []
      this.pickupCount = 1
      this.Route = 1
      this.ChangePickups();
    },
    Save() {
      if(this.Route == "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fehler',
            icon: 'CheckIcon',
            text: 'Es wurde keine Richtung gewählt',
            variant: 'danger',
          },
        })
        return;
      }
      const returnDate = this.FileDate.split('.')
      const returnTime = this.FileTime.split(':')
      let fileDate = new Date('20' + returnDate[2] + '-' + returnDate[1] + '-' + returnDate[0])
      //fileDate = fileDate.setHours(returnTime[0],returnTime[1],0)

      const returnDate2 = this.TravelDay.split('.')
      let TravelDay = new Date('20' + returnDate2[2] + '-' + returnDate2[1] + '-' + returnDate2[0])
      //TravelDay = TravelDay.setHours(12,0,0)
      this.$http.post('/ki/add', JSON.stringify({
        PdfName: this.FileName,
        FileTime: this.FileTime,
        FileDate: fileDate,
        TravelDay: TravelDay,
        Pickups: this.pickups,
        Route: this.Route,
      }))
          .then(resp => {
            if (resp.data.success) {

              this.Next()
            }
          })
    },
    Next() {
      this.Reset();
      this.$http.get('/ki/get/next/pdf')
          .then(resp => {
            if (resp.data.success) {
              this.file = window.location.host == "localhost:8080" ? 'https://localhost:5001' : 'https://api.flughafentransfer.com'
              this.file = this.file + '/ki/get/pdf/8ZxrpAiDK65Nc/' + resp.data.file
              this.FileName = resp.data.file
            }
          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    }
  }
}
</script>

<style scoped>

</style>